<app-styleguide-specimen [rendering]="rendering" e2eId="styleguide-route-fields">
  Route level <code>pageTitle</code> field:
  <span *scText="contextFields.pageTitle"></span>

  <p>
    <a routerLink="/styleguide/custom-route-type">Sample of using a custom route type</a>
  </p>
</app-styleguide-specimen>
